<app-date-picker
	label="Occupancy date"
	[ngModel]="occupancyDate$ | async"
	(ngModelChange)="onChange($event)"
	orientation="row"
	(focus)="_onFocus()"
	[maxDate]="closingDate$ | async"
	maxDateErrorLabel="Closing Date"
	[testHook]="testHooks.OccupancyDateDatePicker"
	[skeletonLoading]="skeletonLoading"
/>
